import React from "react";

const Textarea = ({ id, label, value, onChange, placeholder, rows = 4,isRequired}) => {
  return (
    <div>
      {label && (
        <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
          {label}
          {isRequired && (
            <span className="text-red-500 ml-1 font-bold">*</span>
          )}{" "}
        </label>
      )}
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        className="w-full mt-1 px-3 py-2 border-2 text-black border-gray-300 rounded-md focus:outline-none text-sm resize-none focus:outline-none !focus-visible:outline-none focus:ring-0 focus:border-[#2BACE2]"
      />
    </div>
  );
};

export default Textarea;
